import React from 'react';
import moment from 'moment';

import styles from './AvailableEmployees.css';
import Results from './Results';
import SearchForm from './SearchForm';



const AvailableEmployees = ({
     employees, 
     form, 
     loading,
     events,
     onFormUpdate,
     standardcrews,
     date,
     updateSelectedEmployeeList,
     entity
    
    }) => 
    {  
      
    return (      
  <div className={styles.container}>    
    <SearchForm           
    form={form}       
    onFormUpdate = { onFormUpdate}
    /> 
   
    <Results      
      employees={ employees }
      loading= { loading }
      events= { events}    
      standardcrews = {standardcrews}
      date = {date}
      updateSelectedEmployeeList = {updateSelectedEmployeeList}
      entity={entity}
      
      /> 
     
  </div>
)};

export default AvailableEmployees;
